import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  TextField,
  Button,
  Chip,
} from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SendIcon from '@mui/icons-material/Send';

const CommentsSection = ({ comments }) => {
  const [newComment, setNewComment] = useState('');

  const roleColors = {
    Technician: { bg: '#EFF6FF', color: '#2563EB' },
    Supervisor: { bg: '#F0FDF4', color: '#2E7628' },
  };

  return (
    <Card sx={{ borderRadius: 1, mb: 3 }}>
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
          <ChatBubbleOutlineIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: 'text.primary' }}>
            Comments
          </Typography>
        </Box>

        {/* Comment list */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mb: 2.5 }}>
          {comments.map((comment) => {
            const roleStyle = roleColors[comment.role] || roleColors.Technician;
            return (
              <Box key={comment.id} sx={{ display: 'flex', gap: 1.5 }}>
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    bgcolor: '#E5E7EB',
                    color: '#4B5563',
                  }}
                >
                  {comment.avatar}
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.25 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', color: '#1B2A3D' }}>
                      {comment.author}
                    </Typography>
                    <Chip
                      label={comment.role}
                      size="small"
                      sx={{
                        height: 20,
                        fontSize: '0.625rem',
                        fontWeight: 600,
                        bgcolor: roleStyle.bg,
                        color: roleStyle.color,
                      }}
                    />
                    <Typography sx={{ fontSize: '0.75rem', color: '#9CA3AF', ml: 'auto' }}>
                      {comment.timeAgo}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontSize: '0.8125rem', color: '#4B5563', lineHeight: 1.6 }}>
                    {comment.text}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>

        {/* Add comment input */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pt: 2,
            borderTop: '1px solid #E5E7EB',
          }}
        >
          <Avatar
            sx={{
              width: 36,
              height: 36,
              fontSize: '0.8125rem',
              fontWeight: 600,
              bgcolor: '#1B2A3D',
              color: '#fff',
            }}
          >
            PD
          </Avatar>
          <TextField
            fullWidth
            placeholder="Add a comment..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                fontSize: '0.8125rem',
                '& fieldset': { borderColor: '#E5E7EB' },
              },
            }}
          />
          <Button
            variant="text"
            size="small"
            sx={{ color: '#6B7280', minWidth: 'auto', px: 1 }}
            startIcon={<SendIcon sx={{ fontSize: '18px !important' }} />}
          >
            Add comment
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CommentsSection;
